import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { SingleQuestionResult, SingleQuestionResultProps } from './SingleQuestionResult';

interface YNNQuestionResultProps extends SingleQuestionResultProps {}

const Main = styled.div``;

export const YNNQuestionResult = observer((props: YNNQuestionResultProps) => {
  return (
    <Main className="dol-question ynn-answer">
      <SingleQuestionResult {...props} />
    </Main>
  );
});
